// extracted by mini-css-extract-plugin
module.exports = {"page":"CR","account":"DR","pdp":"ER","cart":"FR","brand":"GR","cartModal":"HR","checkout":"IR"};